export default __webpack_public_path__ + "static/media/frame543_1.47a13e5f.JPG";